module.exports = __webpack_public_path__ + "img/Undo-icon.65ce6cf1.svg";